import {combineReducers} from 'redux';
import carPositionReducer from './carPositionReducer';
import gamePlayReducer from './gameplayReducer';
import pointReducer from './pointsReducer';
import gamePlayedReducer from './gamePlayedReducer';
const rootReducers = combineReducers({
    carpos:carPositionReducer,
    game:gamePlayReducer,
    points:pointReducer,
    gamefinished:gamePlayedReducer
})

export default rootReducers;